export default __webpack_public_path__ + "static/media/pic1.6e8d93fd.jpeg";